import { apiGet, GetReportRequest } from 'api';
import { ReportResponse } from 'types';

export const getRespondedYearToDateReport = (
  request: GetReportRequest
): Promise<ReportResponse> =>
  apiGet<ReportResponse, GetReportRequest>('reports/respondedytd', request);
